"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryCell = void 0;
const tslib_1 = require("tslib");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const typestyle_1 = require("typestyle");
const MarkupStyles_1 = require("../style/MarkupStyles");
const NewCategoryExperience_1 = require("./NewCategoryExperience");
const LabelCategories_1 = require("./shared/LabelCategories");
function CategoryCell(props) {
    const popoverInstance = react_1.default.useRef(null);
    const [categoryDescription, refetch] = (0, NewCategoryExperience_1.useLabelCategoryDescription)(props.categoryName, props.description);
    if ((0, LabelCategories_1.isBuiltInLabelCategory)(props.categoryName)) {
        return react_1.default.createElement(react_1.default.Fragment, null, props.localizedCategoryName);
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(widgets_1.PopoverWidget, { "aria-describedby": 'label-category-popover', placement: 'right', popoverContent: react_1.default.createElement("div", null,
                react_1.default.createElement("h4", null, props.categoryName),
                react_1.default.createElement(MarkupStyles_1.FormattedMarkupWrapperInTooltip, { markup: categoryDescription }),
                react_1.default.createElement("div", { className: PencilIconStyle },
                    react_1.default.createElement(NewCategoryExperience_1.EditCategoryPopover, { categoryName: props.categoryName, onSuccess: refetch }))), ref: popoverInstance, showTitleBar: false, title: props.categoryName, triggerElement: react_1.default.createElement(widgets_1.TextLinkWidget, { kind: widgets_1.TextLinkKind.Standalone, testId: 'label-category-name', style: { fontWeight: 'normal' } }, props
                .categoryName) })));
}
exports.CategoryCell = CategoryCell;
const PencilIconStyle = (0, typestyle_1.style)({
    position: 'absolute',
    top: '30px',
    right: '30px',
});
//# sourceMappingURL=CategoryCell.js.map